import { Spin } from 'antd';
import 'antd/es/spin/style/css';

const ContentLoader = ({ className }) => {
    return (
        <div className={`content-loader ${className ? className : ''}`}>
            <Spin size="large" />
        </div>
    )
};

export default ContentLoader;